import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

export const containerTypeApi = createApi({
  reducerPath: 'containerTypeApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['containerType'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getContainerTypeList: builder.query({
      query: () => ({
        method: 'GET',
        path: 'ContainerTypes',
      }),
      providesTags: ['containerType'],
    }),
    createNewContainerType: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'ContainerTypes',
      }),
      invalidatesTags: ['containerType'],
    }),
    updateContainerType: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'PUT',
        path: 'ContainerTypes',
      }),
      invalidatesTags: ['containerType'],
    }),
    deleteContainerType: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `ContainerTypes/${id}`,
      }),
      invalidatesTags: ['containerType'],
    }),
  }),
});
export const containerTypeApiReducerName = containerTypeApi.reducerPath;
export const containerTypeApiReducer = containerTypeApi.reducer;
export const containerTypeApiMiddleware = containerTypeApi.middleware;

export const {
  useGetContainerTypeListQuery,
  useCreateNewContainerTypeMutation,
  useUpdateContainerTypeMutation,
  useDeleteContainerTypeMutation,
} = containerTypeApi;
